module.exports = __webpack_public_path__ + "static/media/го.4096d39e.mp3";